
export default {
    /**
     * 设置用户信息
     * @param {Object} data 当前需要设置的用户信息
     */
    setUserInfo({commit}, data) {
        commit('setUserInfo', data)
    }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js